import { qubictronUrlMap } from "@qubictron/url";
import cn from "classnames";
import { useTranslation } from "shared/localization/localization";
import { AlertIcon2 } from "shared/ui/Icons/Icons";
import styles from "./DemurrageLink.module.scss";

type DemurageLinkProps = {
  className?: string;
};

export const DemurrageLink: RFC<DemurageLinkProps> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <div className={cn(styles.demurrageLink, className)}>
      <div className={styles.iconWrapper}>
        <AlertIcon2 className={styles.icon} />
      </div>
      <div>
        <span className={styles.text}>{t("Automated caclulation from")}</span>
        <a href={qubictronUrlMap.prod().appendPathname("container/demurrage").build()} target="_blank" rel="noreferrer">
          {t("Demurrage & Storage Calculator")}
        </a>
      </div>
    </div>
  );
};
